import React, { useEffect, useRef, useState } from 'react';
import PropTypes                              from 'prop-types';

import { VideoPlayer } from '../../Gallery/VideoPlayer';

import Flux                            from '../../../flux/Flux';
import GuestAccess                     from '../../../utils/GuestAccess';
import ProfileHeaderDildocontrolButton from '../../ProfileHeader/ProfileHeaderDildocontrolButton';
import Translations                    from '../../../utils/Translations';

const headerimagePlaceholder = '/assets/img/user/vx_new_amateurs_headerimage.jpg';

const EVENT_TYPE_WELCOME_CLIP_PLAY       = 'welcome_clip_play';
const EVENT_CONTEXT_ACTOR_PROFILE_HEADER = 'actor_profile_header';

const BREAKPOINT_LAPTOP  = 850;
const COVER_SIZE_DESKTOP = 500;
const COVER_SIZE_LAPTOP  = 400;
const DEFAULT_SIZE       = window.innerHeight < BREAKPOINT_LAPTOP ? COVER_SIZE_LAPTOP : COVER_SIZE_DESKTOP;

const ActorProfileCover = (props) => {

    const {
        actorId,
        actorName,
        isOnline,
        isDildocontrolAvailable,
        isPlaceholder,
        isVoyeurChatAvailable,
        lineBreak,
        openViewer,
        profileCoverPhotoUrl,
        profileLink,
        isService0900Available,
        welcomeclip
    } = props;

    const [isWelcomeClipPlayerOpen, setIsWelcomeClipPlayerOpen] = useState(false);
    const [coverSize, setCoverSize]                             = useState(DEFAULT_SIZE);
    const [containerHeight, setContainerHeight]                 = useState(DEFAULT_SIZE);
    const [coverPicture, setCoverPicture]                       = useState(
        profileCoverPhotoUrl.includes('placeholder') ? headerimagePlaceholder : profileCoverPhotoUrl
    );
    const [isCoverPictureLoaded, setIsCoverPictureLoaded]       = useState(false);

    const videoPlayerRef          = useRef(null);
    const videoPlayerContainerRef = useRef(null);

    const previewPicRef           = useRef(null);


    useEffect(() => {
        const handleResize = () => {
            const size = window.innerHeight < BREAKPOINT_LAPTOP ? COVER_SIZE_LAPTOP : COVER_SIZE_DESKTOP;
                setCoverSize( prevState => {
                    if(prevState !== size) {
                        return size;
                    }
                    return prevState;
                });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setCoverPicture(profileCoverPhotoUrl);
    }, [profileCoverPhotoUrl])

    useEffect(() => {
        const refToObserve = isWelcomeClipPlayerOpen ? videoPlayerContainerRef?.current : previewPicRef?.current;
        setContainerHeight(refToObserve?.clientHeight);

        const handleResize = () => {
            setContainerHeight(refToObserve?.clientHeight);
        };

        if(refToObserve) {
            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(refToObserve);
            return () => resizeObserver.disconnect();
        };

    }, [isWelcomeClipPlayerOpen, isPlaceholder]);

    const profileImage = {
        actorName:  actorName,
        actorUrl:   profileLink,
        blurImage:  false,
        needBuying: false,
        origUrl:    profileCoverPhotoUrl,
        previewUrl: profileCoverPhotoUrl,
        title:      Translations.get('actor_profile.header-viewer.title'),
        titleUrl:   profileLink,
        type:       "photo",
        url:        profileCoverPhotoUrl,
        width:      1864,
    };

    const onImgLoaded = () => {
        setIsCoverPictureLoaded(true);
    }

    const openWelcomeClipPlayer = (e) => {
        if(welcomeclip.needLogin || welcomeclip.needAvs) {
            e.preventDefault();
            e.stopPropagation();
            GuestAccess.onContentAccess(
                {
                    needLogin:          welcomeclip.needLogin,
                    needAvs:            welcomeclip.needAvs,
                    ignorePaymentFirst: true,
                }
            );
        } else {
            setIsWelcomeClipPlayerOpen(true);
            videoPlayerRef?.current?.shaka.video.play();
        }
    };

    const playPreviewButton = (( welcomeclip && !isWelcomeClipPlayerOpen) &&
        <button
            className = "js-welcomeclip actor-profile-header__btn-welcomeclip -click-material"
            onClick   = {openWelcomeClipPlayer}
        >
            <i className="icon -icon-play-rounded-line"/>
            <div className="clearfix"/>
            <span className="btn--detailed__teaser">
                {Translations.get('ActorProfileHeaderBtnWelcomeclip1')}
            </span>
            <span className="btn--detailed__teaser-text">
                {Translations.get('ActorProfileHeaderBtnWelcomeclip2')}
            </span>
        </button>
    );

    const handleCoverPictureError = () => {
        if(!isPlaceholder) {
            setCoverPicture(headerimagePlaceholder);
        }
    };

    const previewPictureHeader = (
        <div
            onClick   = {!welcomeclip?.source ? (e)=>openViewer(profileImage, e) : null}
            className = {`actor-profile-header__picture ${!welcomeclip?.source ? ' h-cursor-pointer ' : ''} ${isWelcomeClipPlayerOpen ? ' -hidden ' : ''}`}
        >
            {playPreviewButton}
            <img
                ref       = {previewPicRef}
                className = {`actor-profile-header__picture__item ${isCoverPictureLoaded ? '' : '-hidden'}`}
                src       = {coverPicture}
                alt       = {actorName}
                onError   = {handleCoverPictureError}
                onLoad    = {onImgLoaded}
                style     = {{ height:    coverSize, }}
            />
        </div>
    );

    const closeWelcomeClipPlayer = () => {
        setIsWelcomeClipPlayerOpen(false);
        videoPlayerRef?.current?.shaka.video.pause();
    };

    const closeButton = ( isWelcomeClipPlayerOpen &&
        <div
            className = "js-welcomeclip-close actor-profile-header__welcomeclip-close icon -icon-close-line -size-lg h-cursor-pointer"
            onClick   = {closeWelcomeClipPlayer}
        />
    );

    const handleVideoEnd = (video) => {
        video.currentTime = 0;
        closeWelcomeClipPlayer();
    };

    const getEvent = (eventTracker, actorId) => {
        const event   = eventTracker.getNewEvent();
        event.type    = EVENT_TYPE_WELCOME_CLIP_PLAY;
        event.context = EVENT_CONTEXT_ACTOR_PROFILE_HEADER;
        event.source  = 'www';
        event.data    = 'actorId=' + actorId + ';';

        return event;
    };
    const videos  = [
        {
            previewPictureUrls: [{pictureUrl: ''}],
            videoUrls:          [{
                src:    welcomeclip?.source,
                webVTT: welcomeclip?.webVTT,
                type:   'application/x-mpegURL',
            }],
        },
    ];
    const eventTracker     = Flux.Tracker.getEventTracker();
    const trackingEvent    = getEvent(eventTracker, actorId);
    const padding          = (isVoyeurChatAvailable && !lineBreak) ? (isService0900Available ? 170 : 125) : 105;
    const videoAspectRadio = videoPlayerRef?.current?.videoElement?.videoWidth / videoPlayerRef?.current?.videoElement?.videoHeight;
    const tolerance        = 0.5;
    const isVideoSquare    = Math.abs(videoAspectRadio-1) <= tolerance;

	const videoPlayer  =(welcomeclip?.source
        ? <div
            ref       = {videoPlayerContainerRef}
            className = {`actor-profile-header__video-container ${isWelcomeClipPlayerOpen ? '' : '-hidden'}`}
            style     = {{
                height:             isWelcomeClipPlayerOpen ? (isVideoSquare ? '100%' : 'auto') : '0',
                width:              '100%',
                backgroundImage:    `url(${headerimagePlaceholder})`,
                backgroundRepeat:   'no-repeat',
                backgroundSize:     'cover',
                backgroundPosition: 'center',
            }}
        >
            <VideoPlayer
                ref               = {videoPlayerRef}
                initialVideos     = {videos}
                autoplay          = {false}
                additionalUIStyle = {{paddingBottom: padding + 'px'}}
                onFirstPlay       = {() => eventTracker.trackEvent(trackingEvent)}
                onEnded           = {handleVideoEnd}
            />
        </div> : null
    );

    return (
        <div className = {`actor-profile-header__cover`}
            style={{
                position:   'relative',
                maxHeight:  `${containerHeight}px !important`,
                height:     `${containerHeight}px`,
                transition: 'height 0.3s',
            }}
        >

            <ProfileHeaderDildocontrolButton
                isOnline                = {isOnline}
                isDildocontrolAvailable = {isDildocontrolAvailable}
            />
            {closeButton}
            {previewPictureHeader}
            {videoPlayer}
        </div>
    )
}

ActorProfileCover.propTypes = {
    actorId:                  PropTypes.number,
    actorName:                PropTypes.string,
    isDildocontrolAvailable:  PropTypes.bool,
    isOnline:                 PropTypes.bool,
    isVoyeurChatAvailable:    PropTypes.bool,
    openViewer:               PropTypes.func.isRequired,
    profileCoverPhotoUrl:     PropTypes.string,
    profileLink:              PropTypes.string,
    isService0900Available:   PropTypes.bool,
    lineBreak:                PropTypes.bool,
    welcomeclip:              PropTypes.object,
}

export default ActorProfileCover;
